import { Component, HostBinding, input, signal } from '@angular/core';
import { Activity } from '@mira-avant/mtlibs';
import { AngularModule } from '../../../../../modules/angular.module';
import { ZorroModule } from '../../../../../modules/zorro.module';

@Component({
	selector: 'app-carousel-activity',
	standalone: true,
	imports: [AngularModule, ZorroModule],
	templateUrl: './carousel-activity.component.html',
	styleUrl: './carousel-activity.component.scss',
})
export class CarouselActivityComponent {
	public activity = input<Activity | undefined>();
	public selected = input<boolean>(false);
	public started = input<boolean>(false);
	public completed = input<boolean>(false);
	public loading = signal(true);

	@HostBinding('class.completed') get isCompleted() {
		return this.completed();
	}

	@HostBinding('class.started') get isStarted() {
		return this.started();
	}

	ngOnInit() {
		this.preloadImage();
	}

	private preloadImage(): void {
		const act = this.activity();
		if (act?.active_text?.image_uri) {
			const img = new Image();

			img.src = act.active_text.image_uri;

			// Always defer the completion → avoids sync resolution race
			img.decode()
				.then(() => {
					this.loading.set(false);
				})
				.catch(() => {
					// Optional: still hide loader on error
					this.loading.set(false);
				});
		}
	}
}
